PLAYER p1 20 You
PLAYER p2 20 Practice partner
ACTIVE p1
p1 battlefield Mountain
p1 hand Lightning Bolt
p2 battlefield Grizzly Bears
p1 library Forest | copies=20
p2 library Forest | copies=20
